export const carouselMovilidad = [
    {
        "imagen" : "/assets/imgs/Responsable/1.png",
    }
    ,
    {
        "imagen" : "/assets/imgs/Responsable/5.png",
    }
    ,
    {
        "imagen" : "/assets/imgs/Responsable/9.png",
    }
    ,
    {
        "imagen" : "/assets/imgs/Responsable/11.png",
    }
    ,
    {
        "imagen" : "/assets/imgs/Responsable/13.png",
    }
    ,
    {
        "imagen" : "/assets/imgs/Responsable/14.png",
    }
    ,
    {
        "imagen" : "/assets/imgs/Responsable/15.png",
    }
    ,
    {
        "imagen" : "/assets/imgs/Responsable/16.png",
    }
    ,
    {
        "imagen" : "/assets/imgs/Responsable/18.png",
    }
    ,
    {
        "imagen" : "/assets/imgs/Responsable/19.png",
    }
    ,
    {
        "imagen" : "/assets/imgs/Responsable/20.png",
    }
    ,
    {
        "imagen" : "/assets/imgs/Responsable/21.png",
    }
    ,
    {
        "imagen" : "/assets/imgs/Responsable/31.png",
    }
    ,
    {
        "imagen" : "/assets/imgs/Responsable/23.png",
        "url" : "https://docs.google.com/forms/d/e/1FAIpQLSeqSPEFBNOeNYjceBPbwVcVZPOSzoSv8SpOEDhEmGHYZP6T5g/viewform"
       
    }
]